import React from 'react';
import { Link } from 'react-router-dom';

export const Servicesection = () => {
    return (
        <div>
        <div className="container">
                <div className="welcome text-center">
                    <div className="col-12">
                        <br/>
                        <h2>Our Services</h2>
                    </div>
                    <hr/>
                    <div id="service-text" className="col-12">
                    <p>Our services are re-defining customers’ experience through digital solutions.</p>
                    <br/>
                    </div>
                </div>
	
         </div>

<div className="container padding">
<div className="row text-center padding">
	<div className="col-xs-12 col-sm-6 col-md-4">
		
		<img className="icon1" src={'./img/service-icon-1.png'} />
		<h4><b>Digital Innovation Lab</b></h4>
		<p>In the world of business, the words “disrupt, innovate, and transform” have become the new normal.</p>
		<Link role="button" to="/DigitalInnovationLab" className="btn btn-outline-secondary btn-sm">read more</Link>
		<br/><br/>
	</div>
	<div className="col-xs-12 col-sm-6 col-md-4">
		<img className="icon1" src={'./img/service-icon-2.png'}/>
		<h4><b>Software Development</b></h4>
		<p>We translate your ideas and requirements into rich technology solutions on a variety of technology platforms.  </p>
		<Link role="button" to="/SoftwareDevelopment" className="btn btn-outline-secondary btn-sm">read more</Link><br/><br/>
	</div>
	<div className="col-xs-12 col-sm-6 col-md-4">
		<img className="icon1" src={'./img/service-icon-3.png'}/>
		<h4><b>Mobile App Development</b></h4>
		<p>We are an expert in providing scalable and high-quality iOS and Android apps. Techarabiya turns your ideas into appealing and quick apps. </p>
		<Link role="button" to="/MobileApp" className="btn btn-outline-secondary btn-sm">read more</Link><br/><br/>
	</div>
	<div className="col-xs-12 col-sm-6 col-md-4">
		<img className="icon1" src={'./img/service-icon-4.png'}/>
		<h4><b>E-commerce Development & Web Designing</b></h4>
		<p>At Techarabiya, we build innovative e-commerce platform dedicated to your needs or modify existing solutions to help scale up your business. Cross-platform sales automation is one of our specialization. </p>
		<Link role="button" to="/Ecommerce" className="btn btn-outline-secondary btn-sm">read more</Link><br/><br/>
	</div>
	<div className="col-xs-12 col-sm-6 col-md-4">
		<img className="icon1" src={'./img/service-icon-5.png'}/>
		<h4><b>Custom IoT Software Development</b></h4>
		<p>Techarabiya renders internet of things development services, delivering custom apps that harness the power of connected devices to advance lifestyles and empower enterprises with next-generation IoT products.</p>
		<Link role="button" to="/Iot" className="btn btn-outline-secondary btn-sm">read more</Link><br/><br/>
	</div>
	<div className="col-xs-12 col-sm-6 col-md-4">
		<img className="icon1" src={'./img/service-icon-6.png'}/>
		<h4><b>Blockchain Development</b></h4>
		<p>Techarabiya is an emergent Fintech solution 
enterprise. We innovate, we build, and we deliver. Our services are re-defining customers’ experience through digital solutions. We have expertise in blockchain technology and development. </p>
		<Link role="button" to="/Blockchain" className="btn btn-outline-secondary btn-sm">read more</Link><br/><br/>
	</div>

</div>
</div>
</div>

    )
}

export default Servicesection